"use strict";
module.exports = require("@jsdevtools/rehype-toc");
